var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMyRoom(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28.267,
    height: 32.4,
    viewBox: "0 0 28.267 32.4",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1203",
    d: "M194.667 141.585a5.994 5.994 0 0 1 4.259-5.74 5.311 5.311 0 0 0-4.116 8.017l-6.819 8.432a1.09 1.09 0 0 0-.245.711l.027 1.123a1.094 1.094 0 0 0 .637.96 1.093 1.093 0 0 0 .654.085l1.11-.2a1.1 1.1 0 0 0 .65-.385l.531-.66a1.105 1.105 0 0 0 .238-.565l.054-.449a1.12 1.12 0 0 1 .725-.912 1.11 1.11 0 0 0 .729-.9v-.014a1.119 1.119 0 0 1 .725-.892l.01-.007a1.1 1.1 0 0 0 .725-.9 1.122 1.122 0 0 1 .742-.9l.429-.15a1.112 1.112 0 0 0 .5-.351l1.072-1.328a6 6 0 0 1-2.637-4.975z",
    transform: "translate(-177.678 -126.955)",
    style: {
      fill: "#ea7d36"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1204",
    d: "M264.339 46.832a5.768 5.768 0 0 0-10.845-3.612.656.656 0 0 0 .9.214 4.873 4.873 0 0 1 9.09 3.123 5.306 5.306 0 0 0-3.013 10.153v10.845a1.1 1.1 0 0 0 .255.708l.729.857a1.1 1.1 0 0 0 1.1.346 1.106 1.106 0 0 0 .564-.346l.735-.857a1.106 1.106 0 0 0 .261-.708v-.846a1.106 1.106 0 0 0-.17-.591l-.24-.383a1.12 1.12 0 0 1-.011-1.166v-.005a1.1 1.1 0 0 0 0-1.155l-.005-.011a1.115 1.115 0 0 1 0-1.15l.005-.011a1.1 1.1 0 0 0 0-1.155v-.005a1.12 1.12 0 0 1 .011-1.166l.24-.383a1.106 1.106 0 0 0 .17-.591v-2.226a5.313 5.313 0 0 0 .231-9.879zm-2.056 4.284a1.437 1.437 0 1 1 0-2.875 1.419 1.419 0 0 1 .524.1 4.834 4.834 0 0 1-1.278 1.375.745.745 0 0 0 .562.688 5.564 5.564 0 0 0 1.408-1.485 1.42 1.42 0 0 1 .221.757 1.442 1.442 0 0 1-1.438 1.44z",
    transform: "translate(-239.317 -37.098)",
    style: {
      fill: "#ea7d36"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1205",
    d: "M50.693 5.376a5.283 5.283 0 0 0-.1-1.045 4.175 4.175 0 0 0-1.883 1.362 1.343 1.343 0 1 1-1.563-1.637A6.507 6.507 0 0 1 49.7 2.261 5.351 5.351 0 0 0 45.321 0h-11.07a1.185 1.185 0 0 0-1.185 1.185v8.378a1.186 1.186 0 0 0 1.185 1.185h11.07a5.37 5.37 0 0 0 5.372-5.372zM42.983 8a.593.593 0 0 1-.593.593h-6.51A.593.593 0 0 1 35.286 8V2.749a.593.593 0 0 1 .593-.593h6.51a.593.593 0 0 1 .593.593zm5.467 4.784a5.547 5.547 0 0 1 .242-.957 5.1 5.1 0 0 1-.8-.974 5.953 5.953 0 0 1-.841.32 5.606 5.606 0 0 0 1.399 1.614z",
    style: {
      stroke: "#1f0f04",
      strokeWidth: ".8px",
      fill: "#ea7d36"
    },
    transform: "translate(-32.666 .396)"
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyRoom);
export default __webpack_public_path__ + "static/media/my-room.6c3107cb81b9f094b9c9ba60cd5487cf.svg";
export { ForwardRef as ReactComponent };